import { Link, useNavigate, useParams } from "react-router-dom"
import MainLayout from "../../components/layouts/MainLayout"
import { useEffect, useState } from "react"
// import { providerApi } from "../../api/providerApi"
import { Alert, Spin, Collapse, Card } from "antd"
import { PlusCircleOutlined, MinusCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';
import { appointmentApi } from "../../api/appointmentsApi"
const { Panel } = Collapse;

const ShowAppointementView = () => {
    const {id} = useParams()
    const [appointment, setAppointment] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const abortController = new AbortController()
    const navigate = useNavigate()
    
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
      };

    useEffect(() => {
        // Définir la fonction fetchProvider à l'intérieur de useEffect
        const fetch = async () => {
          setLoading(true);
          setError(null);
          try {
            const res = await appointmentApi.getRdv(`${id}`,abortController.signal);
            setAppointment(res.data.appointment); // Stocker les données récupérées

            console.log("details",res.data)
          } catch (err) {
            setError("Impossible de charger les détails du mécano.");
          } finally {
            setLoading(false);
          }
        };
    
        fetch(); // Appeler la fonction immédiatement
    
      }, [id]);
      


    return <MainLayout>
    <div className="container mx-auto p-6">
        <div className="flex justify-between">
            <h1 className="text-3xl font-semibold mb-6">Détails du Rendez-vous</h1>
            <Link to={`/gestion-rdv/liste`}><LeftCircleOutlined/> Retour  </Link>
        </div>

      {loading && <Spin size="large" />}
      {error && <Alert message={error} type="error" />}
      {!loading && !error && appointment && (
        <div className="bg-white p-6 rounded-lg shadow-md">
          {/* Information personnelle */}
          <Collapse defaultActiveKey={['1']} expandIconPosition="start">
            <Panel header="Informations Du Rendez-vous" key="1" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Date du rendez-vous :</strong> {appointment.date_rdv}</p>
                <p><strong>Heure de debut :</strong> {appointment.hour_start_rdv || "Non fourni"}</p>
                <p><strong>Heure de fin :</strong> {appointment.hour_end_rdv || "Non fourni"}</p>
                <p><strong>Status :</strong> {appointment?.status === null && <span className="bg-blue-700 text-white text-sm p-2 rounded-lg">En attente</span>} 
                        {appointment?.status === "ACCEPTED" && <span className="bg-green-700 text-white text-sm p-2 rounded-lg">Accepte</span>} 
                        {appointment?.status === "REFUSED" && <span className="bg-red-700 text-white text-sm p-2 rounded-lg">Refuse</span> }</p>
                

                <p><strong>Date de la demande :</strong> {formatDate(appointment.created_at)}</p>
              </div>
            </Panel>
          </Collapse>

          {/* Information sur les contacts */}
          <Collapse defaultActiveKey={['2']} expandIconPosition="start" className="mt-4">
            <Panel header="Informations du client" key="2" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Nom Complet :</strong> {appointment.client?.name} {appointment.client?.lastname}</p>
                <p><strong>Contact :</strong> {appointment.client?.contact || "Non fournie"}</p>
                <p><strong>Email :</strong> {appointment.client?.email || "Non fournie"}</p>
                <p><strong>Adresse :</strong> {appointment.client?.adresse || "Non fournie"}</p>
                <p><strong>Ville :</strong> {appointment.client?.ville || "Non fournie"}</p>
              </div>
            </Panel>
          </Collapse>

          {/* Information sur la société */}
          <Collapse defaultActiveKey={['3']} expandIconPosition="start" className="mt-4">
            <Panel header="Informations du prestaire" key="3" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">

                <p><strong>Nom Complet :</strong> {appointment.mecanicien?.name} {appointment.mecanicien?.lastname}</p>
                <p><strong>Contact :</strong> {appointment.mecanicien?.contact || "Non fournie"}</p>
                <p><strong>Email :</strong> {appointment.mecanicien?.email || "Non fournie"}</p>
                <p><strong>Adresse :</strong> {appointment.mecanicien?.adresse || "Non fournie"}</p>
                <p><strong>Ville :</strong> {appointment.mecanicien?.ville || "Non fournie"}</p>
                <p><strong>Specialite :</strong> {appointment.mecanicien?.speciality || "Non fournie"}</p>
                

                <p><strong>Nom de la société :</strong> {appointment?.mecanicien?.societe.libelle || "Non fourni"}</p>
                <p><strong>Lieu :</strong> {appointment?.mecanicien?.societe.lieu || "Non fournie"}</p>
                <p><strong>Experience :</strong> <a href={appointment.mecanicien?.experience} target="_blank" rel="noopener noreferrer">{appointment.website || "Non fourni"}</a></p>


                
              </div>
            </Panel>
          </Collapse>

          {/* Presentation/description*/}
          <Collapse defaultActiveKey={['4']} expandIconPosition="start" className="mt-4">
            <Panel header="Description du prestataire" key="4" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p>{appointment?.mecanicien?.societe.presentation || "Non fourni"}</p>
                </div>
            </Panel>
          </Collapse>
        </div>
      )}
    </div>
  </MainLayout>

}
export default ShowAppointementView